// =================================
// Basic Environmental Detection ===
// =================================

/**
 * Where to direct user if they logged in and visit landing/signIn page
 */
export const defaultAuthenticatedLanding: string = "/";

/**
 * Check whether the app is being served from localhost
 * @return boolean
 */
export const isLocal: boolean = window.location.hostname.includes("localhost");

/**
 * Check whether the app is being served outside of production
 * @return boolean
 */
export const isDev: boolean = isLocal || window.location.hostname.includes(".t.");

export const isProd: boolean = !isDev;
export const fileUploadToken: string = "5ddba2a7645bb3fa029ab8140c4b0d40";

/**
 * Check whether the user is an internal user
 * @return boolean
 */
export const isInternal: boolean = (function () {
  const mb_internal: string | null = sessionStorage.getItem("mb_internal");
  return mb_internal && JSON.parse(mb_internal);
})();

/**
 * Array of supported languages by language code
 * en = English
 * de = German
 * es = Spanish
 * @return array<string>
 */
export const supportedLanguages: string[] = ["en", "de", "es"];
